import { SearchHeader } from "./SearchHeader";
import { CategoryCarousel, type CategoryForCarousel } from "./CategoryCarousel";
import { cn } from "@wondermaps/ui";
import type { HeadlineSponsor } from "./sponsor-types";
import type { VisitorNotification } from "./notification-types";

interface ControlHeaderProps {
  className?: string;
  style?: React.CSSProperties;
  isListViewOpen: boolean;
  isSearchMode: boolean;
  searchQuery: string;
  onSearchChange: (query: string) => void;
  searchInputRef: React.RefObject<HTMLInputElement>;
  onSearchOpen: () => void;
  onSearchClose: () => void;
  categories: CategoryForCarousel[];
  selectedCategory: string;
  onSelectCategory: (slug: string) => void;
  poiCounts: Record<string, number>;
  logoUrl?: string;
  appName?: string;
  savedCount?: number;
  happeningNowCount?: number;
  isEmbed?: boolean;
  headlineSponsor?: HeadlineSponsor | null;
  brandAccentPills?: string | null;
  brandAccentIcons?: string | null;
  /** Notifications + share for the floating island in SearchHeader */
  notifications?: VisitorNotification[];
  onBellClick?: () => void;
  isTrayOpen?: boolean;
  mapSlug?: string;
  shareUrl?: string;
  shareTitle?: string;
  shareText?: string;
}

/**
 * Control header for visitor map - combines SearchHeader and CategoryCarousel
 * Hidden when list view is open (list view has its own search)
 */
export function ControlHeader({
  className,
  style,
  isListViewOpen,
  isSearchMode,
  searchQuery,
  onSearchChange,
  searchInputRef,
  onSearchOpen,
  onSearchClose,
  categories,
  selectedCategory,
  onSelectCategory,
  poiCounts,
  logoUrl,
  appName,
  savedCount,
  happeningNowCount,
  isEmbed,
  headlineSponsor,
  brandAccentPills,
  brandAccentIcons,
  notifications,
  onBellClick,
  isTrayOpen,
  mapSlug,
  shareUrl,
  shareTitle,
  shareText,
}: ControlHeaderProps) {
  if (isListViewOpen) return null;

  return (
    <div className={cn("pt-safe", className)} style={style}>
      <SearchHeader
        isSearchMode={isSearchMode}
        onSearchOpen={onSearchOpen}
        onSearchClose={onSearchClose}
        searchQuery={searchQuery}
        onSearchChange={onSearchChange}
        inputRef={searchInputRef}
        logoUrl={logoUrl}
        appName={appName}
        isEmbed={isEmbed}
        headlineSponsor={headlineSponsor}
        notifications={notifications}
        onBellClick={onBellClick}
        isTrayOpen={isTrayOpen}
        mapSlug={mapSlug}
        shareUrl={shareUrl}
        shareTitle={shareTitle}
        shareText={shareText}
        brandAccent={brandAccentIcons}
      />
      <div className="pointer-events-auto">
        <CategoryCarousel
          categories={categories}
          selectedCategory={selectedCategory}
          onSelectCategory={onSelectCategory}
          poiCounts={poiCounts}
          savedCount={savedCount}
          happeningNowCount={happeningNowCount}
          className="bg-transparent shadow-none backdrop-blur-none"
          brandAccent={brandAccentPills}
        />
      </div>
    </div>
  );
}
